import React from 'react'
import Img from 'gatsby-image'
import { graphql } from 'gatsby'
import Banner from '../components/banner'
import StartupCarousel from '../components/startup-carousel'
import ReactMarkdown from 'react-markdown'

const CompanyCell = ({ node: { name, url, logo } }) => {
  if (logo) {
    return (
      <a key={name} href={url}>
        <span style={{ zIndex: -1, position: 'absolute' }}>{name}</span>
        <div className="gatsby-image-outer-wrapper">
          <Img
            imgStyle={{ objectFit: "unset" }}
            fluid={logo.childImageSharp.fluid} />
        </div>
      </a>
    )
  }

  return (
    <a key={name} href={url}>
      {logo}
    </a>
  )
}

const StartupsPage = ({ data }) => {
  const companies = data?.carouselStartups?.edges
  return (
    <div>
      <Banner
        data={data.strapiOurStartups}
        credit="Jessica Monroy"
        creditLeft={true}
      />
      <div className="content-body">
        <h1>{data.strapiOurStartups.header_part.header}</h1>

        <ReactMarkdown>
          {data.strapiOurStartups.header_part.description}
        </ReactMarkdown>

        <StartupCarousel companies={companies} />
        <div className="logos small">
          {data.smallLogoStartups.edges.map(({ node }) => (
            <CompanyCell key={node.name} node={node} />
          ))}
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query StartupsQuery {
    strapiOurStartups {
      header_part {
        header
        description
      }
      mobile_banner {
        ...MobileBannerSizes
      }
      desktop_banner {
        ...DesktopBannerSizes
      }
    }

    smallLogoStartups: allStrapiStartup(
      filter: { display_on_homepage: { eq: false } }
      sort: { order: ASC, fields: name }) {
      edges {
        node {
          name
          url
          display_on_homepage
          folio_id
          logo {
            childImageSharp {
              fluid(maxWidth: 124) {
                ...GatsbyImageSharpFluid_tracedSVG
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }

    carouselStartups: allStrapiStartup(
      filter: { carousel_logo: { id: {ne: null} } }
      sort: { order: [ASC, ASC], fields: [display_order, name] }
    ) {
      edges {
        node {
          name
          url
          display_on_homepage
          carousel_logo {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid_tracedSVG
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }
  }
`

export default StartupsPage
